import React, {useState} from 'react';
import CustomNavbar from '../../components/CustomNavbar';
import { Row, Container, Col, Card } from 'react-bootstrap';
import { Bar, Line } from 'react-chartjs-2';
import { Button } from 'react-bootstrap';
import SidebarDashboard from '../../components/SidebarDashboard';

const DashboardH = () => {
  const [show, setShow] = useState(false);

  const skipped = (ctx, value) => ctx.p0.skip || ctx.p1.skip ? value : undefined;
  const down = (ctx, value) => ctx.p0.parsed.y > ctx.p1.parsed.y ? value : undefined;
  const data = {
    labels: ['Red', 'Blue', 'Yellow', 'Green', 'Purple', 'Orange'],
    datasets:[{
      label: '# de votos',
      data: [12, 19, 3, 5, 2, 3],
      backgroundColor: [
        '#e6150f',
        '#e6150f',
        '#e6150f',
        '#e6150f',
        '#e6150f',
        '#e6150f'
      ],
      borderColor: [
        '#e6150f',
        '#e6150f',
        '#e6150f',
        '#e6150f',
        '#e6150f',
        '#e6150f'
      ],
      borderWidth: 1,
      borderRadius: Number.MAX_VALUE,
      borderSkipped: false
    }]
  }
  const lineData = {
    labels: ['Red', 'Blue', 'Yellow', 'Green', 'Purple', 'Orange'],
    datasets: [{
      label: "# de votos",
      data: [12, 19, 3, 5, 2, 3],
      borderColor: 'rgb(75, 192, 192)',
      segment: {
        borderColor: ctx => skipped(ctx, 'rgb(0,0,0,0.2)') || down(ctx, 'rgb(192,75,75)'),
        borderDash: ctx => skipped(ctx, [6, 6]),
      }
    }]
  }

  const onShowSidebar = () => setShow(show ? false : true);
  return (
    <>
      <CustomNavbar  type={'dashboard'} onShowSidebar={onShowSidebar} />
      <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <Card className="border-0">
            <Card.Body>
              <Row>
                <Col md="3" className="mb-2 mb-sm-0">
                  <Card className="border-0">
                    <Card.Body className="dashboard-card dashboard-card-or">
                      <h1 className="font-weight-bold title">3,980</h1>
                      <i className="material-icons icon">face</i>
                      <p className="footer"><span className="font-weight-bold footer">5.6%</span> vs el año pasado</p>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md="3" className="mb-2 mb-sm-0">
                  <Card className="border-0 ">
                    <Card.Body className="dashboard-card dashboard-card-jo">
                      <h1 className="font-weight-bold title">3,980</h1>
                      <i className="material-icons icon">face</i>
                      <p className="footer"><span className="font-weight-bold footer">5.6%</span> vs el año pasado</p>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md="3" className="mb-2 mb-sm-0">
                  <Card className="border-0">
                    <Card.Body className="dashboard-card dashboard-card-re">
                      <h1 className="font-weight-bold title">3,980</h1>
                      <i className="material-icons icon">face</i>
                      <p className="footer"><span className="font-weight-bold footer">5.6%</span> vs el año pasado</p>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md="3">
                  <Card className="border-0 ">
                    <Card.Body className="dashboard-card dashboard-card-bl">
                      <h1 className="font-weight-bold title">3,980</h1>
                      <i className="material-icons icon">face</i>
                      <p className="footer"><span className="font-weight-bold footer">5.6%</span> vs el año pasado</p>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Card.Body>
          </Card>
          <Row className="my-3">
            <Col md="8" className="mb-3 mb-sm-0">
              <Card className="border-0 shadow bg-dark"> 
                <Card.Body>
                  <small className="text-white">FARINTER</small>
                  <h5 className="text-white">Encuestas aplicadas</h5>
                  <Line height={155} data={lineData} options={{
                  fill: false,
                  interaction: {
                    intersect: false
                  },
                  radius: 0
                }}  />
                </Card.Body>
              </Card>
            </Col>
            <Col md="4">
              <Card className="border-0 shadow">
                <Card.Body>
                  <small>FARINTER</small>
                  <h5>Encuestas aplicadas</h5>
                  <Bar height={350} data={data} options={{
                    responsive: true,
                    plugins: {
                      legend: {
                        position: 'top',
                      },
                      title: {
                        display: false,
                        text: 'Chart.js Bar Chart'
                      }
                    }
                  }} />  
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <Row className="my-5">
            <Col md="4" className="mb-2 mb-sm-0">
              <Card className="border-0 shadow">
                <Card.Body>
                  <h6 className="mb-3 font-weight-bold"><i className="material-icons mr-2 text-warning">add</i>CREAR</h6>
                  <ul className="list-unstyled">
                    <li className="d-flex justify-content-between align-items-center mb-3">
                      <h6>Item #1</h6>
                      <Button variant="primary" size="sm">Encuesta</Button>
                    </li>
                    <li className="d-flex justify-content-between align-items-center mb-3">
                      <h6>Item #1</h6>
                      <Button variant="primary" size="sm">Encuesta</Button>
                    </li>
                    <li className="d-flex justify-content-between align-items-center">
                      <h6>Item #1</h6>
                      <Button variant="primary" size="sm">Encuesta</Button>
                    </li>
                  </ul>
                </Card.Body>
              </Card>
            </Col>
            <Col md="4" className="mb-2 mb-sm-0">
              <Card className="border-0 shadow">
                <Card.Body>
                  <h6 className="mb-3 font-weight-bold"><i className="material-icons mr-2 text-success">bolt</i>GESTIONAR</h6>
                  <ul className="list-unstyled">
                    <li className="d-flex justify-content-between align-items-center mb-3">
                      <h6>Item #1</h6>
                      <Button variant="primary" size="sm">Encuesta</Button>
                    </li>
                    <li className="d-flex justify-content-between align-items-center mb-3">
                      <h6>Item #1</h6>
                      <Button variant="primary" size="sm">Encuesta</Button>
                    </li>
                    <li className="d-flex justify-content-between align-items-center">
                      <h6>Item #1</h6>
                      <Button variant="primary" size="sm">Encuesta</Button>
                    </li>
                  </ul>
                </Card.Body>
              </Card>
            </Col>
            <Col md="4" className="mb-2 mb-sm-0">
              <Card className="border-0 shadow">
                <Card.Body>
                  <h6 className="mb-3 font-weight-bold"><i className="material-icons mr-2 text-danger">list_alt</i>REPORTES</h6>
                  <ul className="list-unstyled">
                    <li className="d-flex justify-content-between align-items-center mb-3">
                      <h6>Reporte #1</h6>
                      <Button variant="primary" size="sm">Encuesta</Button>
                    </li>
                    <li className="d-flex justify-content-between align-items-center mb-3">
                      <h6>Reporte #2</h6>
                      <Button variant="primary" size="sm">Encuesta</Button>
                    </li>
                    <li className="d-flex justify-content-between align-items-center">
                      <h6>Reporte #3</h6>
                      <Button variant="primary" size="sm">Encuesta</Button>
                    </li>
                  </ul>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  )
}

export default DashboardH
